import $ from 'jquery';

/**
 * Generic function to return calculated BMI (body mass index) given height and weight
 * @param {Number} heightFt The height value in feet
 * @param {Number} HeightIn The height value in inches
 * @param {Number} weight The weight value in pounds
 * @returns {Number} The bmi as float
 */
export function calculateBmi(heightFt, heightIn, weight) {
  const height = (parseInt(heightFt) * 12) + parseInt(heightIn)
  const bmi = (parseFloat(weight) / (height ** 2)) * 703

  return bmi
}

/**
 * Generic function to return calculated BMI (body mass index) given height and weight using CM and KG as units
 * @param {Number} height The height value in CM
 * @param {Number} weight The weight value in KG
 * @returns {Number} The bmi as float
 */
export function calculateBmiKG(height, weight) {
  return parseFloat(weight) / (parseFloat(height) ** 2)
}

/**
 * Generic function to return the reverse BMI (body mass index) given the goal BMI and height.
 * It returns the neede weight to gain the BMI.
 * @param {Number} goalBmi The wanted BMI
 * @param {Number} heightFt The height value in feet
 * @param {Number} HeightIn The height value in inches
 * @returns {Number} The needed weight to get the BMI
 */
export function reverseBmi(goalBmi, heightFt, heightIn) {
  const height = (((parseInt(heightFt) * 12) + parseInt(heightIn)) ** 2)
  return (goalBmi / 703) * height
}

/**
 * Generic function to return the reverse BMI (body mass index) given the goal BMI and height using CM and KG as units.
 * It returns the neede weight to gain the BMI.
 * @param {Number} goalBmi The weight value in KG
 * @param {Number} height The height value in CM
 * @returns {Number} The neede weight to get the BMI
 */
export function reverseBmiKG(goalBmi, height) {
  return (parseFloat(height) ** 2) * parseFloat(goalBmi)
}

export const GENERIC_ERROR_MSG = 'Something went wrong when trying to submit your answers. Please try again or contact support if the problem persists.';
export const API_URL = window.location.origin;
export const POST_API_URL = `${API_URL}/weight-loss-bet/funnel_information/`;

function getCookieValue(a) {
  const b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}

export function isUserLoggedIn() {
  return getCookieValue('logged_in') === 'True'
}

export function numericValueError(value) {
  const v = (value).toString();
  return isNaN(value) || v.includes('e') || v.includes('.');
}

export function isInt(value) {
  return value % 1 === 0
}

/* Copied from calculator.js. Keep both sync */
const LBS_TO_KG_RATIO = 0.45359237;

function convertWeightToLbs(weight) {
  return weight / LBS_TO_KG_RATIO
}

export function mapFullStoreToParams(nyop) {
  const data = $.extend({}, nyop);
  data.weightUnit = nyop.units.includes('lb') ? 'lb' : 'kg';
  data.wager = parseInt(nyop.bet.wager);
  data.length = parseInt(nyop.bet.length);
  data.goal = nyop.bet.goal;

  if (nyop.units === 'kg') {
    data.kilograms = data.pounds;
    delete data.pounds;
    data.goal = convertWeightToLbs(data.goal);
  }
  data.hft = nyop.hft;

  delete data.units;
  delete data.bet;

  return data;
}

export function isEmptyData(data) {
  return !data || !data.gender || !data.feet || !data.inches || (!data.pounds && !data.kilograms);
}

export function alertAndRedirectToFunnelUrl(data) {
  alert('It appears that some values were not provided or were missed, please fill all the required values.');
  window.location.href = data.js_full_url ? data.js_full_url : '/healthywager/';
}
